export const ESchmetterlingOrderStatus = {
   "-1": "ALL",
   0: "UNKNOWN",
   200: "BOOKED",
   202: "CANCELED",
   205: "DISPLAYED",
   213: "RESERVED",
};
